<template>
  <a-card :bordered="false">
    <search-page-view
      :col="4"
      ref="pageList"
      :itemNames="searchItemList"
      :columns="columns"
      :queryParams="queryParams"
      row-key="id"
      :leftSpace="10"
      :requestPromise="getList"
      :pageSize="20"
      expandedRowRender="expandedRowRender"
    >
      <a-form-item slot="search_orderNo" label="订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
      </a-form-item>
      <span slot="index" slot-scope="rowItem">
        {{ rowItem.index + 1 }}
      </span>
      <template slot="expandedRowRender" slot-scope="rowItem">
        <div style="display: flex;line-height: 28px" v-for="(item,index) in rowItem.record.expressOrderRelationList"
             :key="index">
          <span style="width:260px;">订单号：{{ item.relationOrderNo }}</span>
          <span style="flex:1;overflow: hidden;text-overflow: ellipsis;white-space: nowrap; ">{{
              item.relationOrderName
            }}</span>
        </div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../utils/mixins/searchFormMixins'

export default {
  name: 'LogisticsUsageRecord',
  mixins: [searchForm],
  data() {
    return {
      searchItemList: ['search_orderNo'],
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: { customRender: 'index' }
        },
        {
          title: '快递公司',
          dataIndex: 'expressName'
        },
        {
          title: '物流单号',
          dataIndex: 'expressNo'
        },
        {
          title: '跟踪状态',
          dataIndex: 'expressStatusName'
        },
        {
          title: '查询时间',
          dataIndex: 'gmtCreate'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    getList(params) {
      return this.getHttpServices().getServerApiService().post('express/query/merchant/orderRelation', params)
    }
  }
}
</script>

<style scoped>
.head-picture {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  border: none;
}
</style>
